"use client";

import { Link } from "@/i18n/navigation";
import { CustomButton } from "@/components/ui/custom-button";

interface CTABannerProps {
	title: string;
	description: string;
	buttonText?: string;
	buttonHref?: string;
	className?: string;
}

export function CTABanner({ 
	title, 
	description, 
	buttonText = "Book a demo",
	buttonHref = "/book-a-demo",
	className = "" 
}: CTABannerProps) {
	return (
		<section className={`relative py-8 px-4 md:px-0 md:py-12 bg-linear-to-l from-ss-light-green via-ss-green to-ss-blue rounded-3xl overflow-hidden ${className}`}>
			{/* Decorative SVG positioned on the right - matching content_download format */}
			<div className="absolute top-0 right-0 w-full h-full pointer-events-none z-0">
				<div className="relative w-full h-full flex items-start justify-end overflow-hidden">
					<div className="w-[430px] top-[-215px] left-[150px] lg:left-[-100px] transition-all duration-500 ease-in-out relative">
						<img
							src="/two_lines.svg"
							alt="Illustration of the StudyStash teaching-learning loop"
							className="w-full h-full object-contain transition-all duration-500 ease-in-out"
							style={{
								transform: 'scale(0.6) translateX(0%)'
							}}
						/>
					</div>
				</div>
			</div>
			
			<div className="max-w-4xl ml-0 mr-auto px-4 sm:px-6 lg:px-8 relative z-10">
				<div className="text-white max-w-[90%] lg:max-w-[80%]">
					<h2 className="text-3xl lg:text-4xl font-bold mb-4 leading-tight text-white">
						{title}
					</h2>
					
					<p className="text-base lg:text-lg mb-6 leading-relaxed opacity-90 text-white">
						{description}
					</p>
					
					{/* Button - left aligned under text */}
					<div className="flex flex-col sm:flex-row gap-4 pt-8">
						<Link href={buttonHref}>
							<CustomButton variant="primary" size="lg">
								{buttonText}
							</CustomButton>
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
}
